export async function fetchWithInterceptor(url, options = {}) {
  try {
    const response = await fetch(url, options);
    if (!response.ok) {

      if (response.status === 401 || response.status === 403) {
        window.location.href = '/';
        return;
      }
    }
    return response;
  } catch (error) {
    throw error;
  }
}